export const environment = {
  production: false,
  local: false,
  apiUrl: 'https://famulusbackend.rrsolutionstest.it/api/external/',
};
